import { useState, useEffect } from 'react';

const SECTION_CLICKED_KEY = 'gpcommit_section_clicked';

export const useMapOnboarding = () => {
  const [showClickHints, setShowClickHints] = useState(false);

  useEffect(() => {
    const hasClickedSection = localStorage.getItem(SECTION_CLICKED_KEY);
    if (!hasClickedSection) {
      setShowClickHints(true);
    }
  }, []);

  const markSectionClicked = () => {
    localStorage.setItem(SECTION_CLICKED_KEY, 'true');
    setShowClickHints(false);
  };

  return { showClickHints, markSectionClicked };
};
